import { FloatLabel } from 'primeng/floatlabel';
import { InputText } from 'primeng/inputtext';
import { ReactiveFormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { Password } from 'primeng/password';
import { FloatLabelErrorMessagesDirective } from 'app/shared/directives/float-label-error-messages.directive';
import { PasswordRuleHintsComponent } from 'app/shared/password-validation';

export const importedModules = [
  FloatLabel,
  FloatLabelErrorMessagesDirective,
  InputText,
  ReactiveFormsModule,
  Button,
  Password,
  PasswordRuleHintsComponent,
];
